import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { UIDepartments } from 'features/Dealers/DealerConfiguration/Departments/state/types';
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import { serviceLoading } from 'common/loaderReducer';
import { GET_ENGINELOCATIONS_API_REQUEST, GET_LMDEPARTMENTS_API_REQUEST } from 'features/Dealers/DealerConfiguration/Departments/state/actionTypes';
import { getLMDepartmentsAPI } from 'features/Dealers/DealerConfiguration/Departments/state/actions';
import { getEngineLocationsAPI } from 'features/Dealers/DealerConfiguration/Departments/state/actions';
import { EngineLocations } from 'features/Dealers/DealerConfiguration/Departments/state/types';
import EditDepartments from "./EditDepartments"
import ViewDepartments from "./ViewDepartments"
import Loader from 'components/Loader';
import { ListingByDealerState } from "features/Dealers/Listings/state/reducer"
import { Redirect, Route, Switch } from 'react-router';
import { TabBody } from 'features/Dealers/DealerConfiguration/styles';

interface location {
    displayName: string;
}

interface department {
    displayName: string;
    location: location;
    id: string;
}

interface LMDepartmentsProps {
    isLoading: boolean
    departments?: UIDepartments
    locations?: EngineLocations
    selectedDealer?: Dealer
    listingsByDealerId: ListingByDealerState
}

const LMDepartmentsUI = () => {
    const dispatch = useDispatch();

    const {
        isLoading,
        departments,
        locations,
        selectedDealer,
        listingsByDealerId
    }: LMDepartmentsProps = useSelector((rootState: RootState) => {
        return {
            isLoading: serviceLoading(rootState, [GET_LMDEPARTMENTS_API_REQUEST]) || serviceLoading(rootState, [GET_ENGINELOCATIONS_API_REQUEST]),
            departments: rootState.dealers.departments.departments,
            locations: rootState.dealers.departments.engineLocations,
            listingsByDealerId: rootState.dealers.listing.listings.byDealerId,
            selectedDealer: rootState.dealers.dealer.selectedDealer
        }
    }, shallowEqual);

   
    
    
    
    if (isLoading) {
        return (
            <Loader />
        )
    }

    return (
        
            <EditDepartments></EditDepartments>
             
    )
}

export default LMDepartmentsUI

